import React, { useState } from 'react';
import { Container, Paper, Typography, Button, TextField, Box } from '@mui/material';
import { accountSyncService } from '../services/accountSyncService';

const TestAddPhone: React.FC = () => {
  const [mainPhone, setMainPhone] = useState('01025619689');
  const [additionalPhone, setAdditionalPhone] = useState('01012345678');
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const handleAddPhone = async () => {
    setLoading(true);
    setResult('Processing...');
    
    try {
      // 추가폰을 그룹에 등록
      await accountSyncService.addToGroup(
        mainPhone,
        [additionalPhone],
        'test-user'
      );
      
      setResult(`Successfully added ${additionalPhone} to ${mainPhone}'s group`);
      
      // 그룹 멤버 확인
      const members = await accountSyncService.getGroupMembers(mainPhone);
      setResult(prev => prev + '\n\nGroup members:\n' + JSON.stringify(members, null, 2));
      
    } catch (error: any) {
      setResult(`Error: ${error.message}`);
      console.error('Add phone error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckGroup = async () => {
    setLoading(true);
    setResult('Checking...');
    
    try {
      const members = await accountSyncService.getGroupMembers(mainPhone);
      const groupId = await accountSyncService.getGroupId(mainPhone);
      
      setResult(`Group ID: ${groupId}\n\nGroup members:\n${JSON.stringify(members, null, 2)}`);
    } catch (error: any) {
      setResult(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Test Add Phone to Group
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
          <TextField
            label="Main Phone Number"
            value={mainPhone}
            onChange={(e) => setMainPhone(e.target.value)}
            fullWidth
          />
          
          <TextField
            label="Additional Phone Number"
            value={additionalPhone}
            onChange={(e) => setAdditionalPhone(e.target.value)}
            fullWidth
          />
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              variant="contained" 
              onClick={handleAddPhone}
              disabled={loading}
            >
              Add Phone to Group
            </Button>
            
            <Button 
              variant="outlined" 
              onClick={handleCheckGroup}
              disabled={loading}
            >
              Check Group Members
            </Button>
          </Box>
          
          {result && (
            <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
              <Typography variant="body2" component="pre" sx={{ fontFamily: 'monospace' }}>
                {result}
              </Typography>
            </Paper>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default TestAddPhone;